import { useQuery } from "@tanstack/react-query";
import { getCalendarEvents } from "../api/calendarEventsApi";

function extractUniqueCleanTitle(text: any) {
  // Danh sách các cụm cần loại bỏ
  const blacklist = [
    "bắt đầu",
    "kết thúc",
    "tới hạn",
    "should be completed",
    "is scheduled for",
  ];
  const pattern = new RegExp(`\\b(${blacklist.join("|")})\\b`, "gi");
  const cleaned = text.replace(pattern, "").trim();
  const parts = cleaned.split("-").map((p:any) => p.trim());
  const unique = [...parts];
  return unique[0] || "";
}

export const useHandleCalendarEvents = (params: any) => {
  const { data: calendarEvents, isLoading: isCalendarEventsLoading } = useQuery(
    {
      queryKey: ["Calendar-event", params],
      queryFn: async () => {
        const response = await getCalendarEvents(params);
        if (response?.events) {
          const events = response.events.map((ev: any) => {
            const name = extractUniqueCleanTitle(ev.name);
            const start = new Date(ev.timestart * 1000);
            const end = new Date(ev.timeend * 1000);
            return {
              id: ev.id,
              title: name,
              start: start,
              end: end,
              timeduration: ev.timeduration,
              description: ev.description,
              eventtype: ev.eventtype,
              modulename: ev.modulename,
            };
          });
          return events;
        }
        return [];
      },
    }
  );
  return {
    calendarEvents,
    isCalendarEventsLoading,
  };
};
